module.exports = __webpack_public_path__ + "media/images/shared/icon-membershipFormUnderAge-63ebcac40be1ff850a0cddf35cda8226.png";